export const isServiceOnDepartureDay = (dayOfService = 1, nights = 1) => (dayOfService > nights ? { OnDepartureDay: true } : {});

export const isDmcArranged = segment => segment.arrangedBy === 'DMC';
export const isOwnArranged = segment => segment.arrangedBy === 'Agent';
